module.exports = __webpack_public_path__ + "static/media/emirates.48363f4c.png";